import { useCallback, useEffect } from 'react'

export function useAiAskBarAttachmentEffects({ attachments, attachmentsRef }) {
  useEffect(() => {
    attachmentsRef.current = attachments
  }, [attachments, attachmentsRef])

  const revokePreviewUrls = useCallback((items) => {
    items.forEach((item) => {
      if (item.previewUrl) URL.revokeObjectURL(item.previewUrl)
    })
  }, [])

  useEffect(() => {
    return () => revokePreviewUrls(attachmentsRef.current)
  }, [attachmentsRef, revokePreviewUrls])

  return { revokePreviewUrls }
}
